// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"dad270521ac62965","3451":"c3ff4ddae3923660","4157":"982a2a40a0080442"}[chunkId] + ".css";
};